module.exports = "/images/vendor/flag-icon-css/flags/4x3/it.svg?8d15de04f5f6e8e89cab4e5eb237f607";